export default __webpack_public_path__ + "static/media/Governance.0f81d77b.svg";